export const SURVEY_TRACKING_PARAM = "t";

export const getSurveyTrackingStorageKey = (formId) =>
  formId ? `survey_${formId}_t` : null;

export const persistSurveyTrackingToken = (formId, searchParams) => {
  const token = searchParams?.get?.(SURVEY_TRACKING_PARAM);
  const storageKey = getSurveyTrackingStorageKey(formId);

  if (token && storageKey) {
    localStorage.setItem(storageKey, token);
  }
};

export const getSurveyTrackingToken = (formId, searchParams) => {
  const fromUrl = String(
    searchParams?.get?.(SURVEY_TRACKING_PARAM) ||
      searchParams?.get?.("token") ||
      "",
  ).trim();

  if (fromUrl) {
    return fromUrl;
  }

  const storageKey = getSurveyTrackingStorageKey(formId);
  const stored = storageKey ? localStorage.getItem(storageKey) : null;

  return stored?.trim() || null;
};

export const appendSurveyTrackingParam = (payload, formId, searchParams) => {
  const token = getSurveyTrackingToken(formId, searchParams);

  if (!token) {
    return payload;
  }

 return {
    ...payload,
    t: token,
  };
};

export const withSurveyQueryString = (path, searchParams) => {
  const queryString = searchParams?.toString?.() || "";

  return queryString ? `${path}?${queryString}` : path;
};

const OPEN_PANEL_ACCESS_STATUSES = new Set([
  "valid",
  "unused",
  "pending",
  "ok",
  "open",
  "active",
  "allowed",
]);

export const getPanelSurveyAccessBlock = (surveyAccessData) => {
  if (!surveyAccessData) return null;

  const status = String(
    surveyAccessData.status || surveyAccessData.access_status || "",
  ).toLowerCase();

  if (OPEN_PANEL_ACCESS_STATUSES.has(status)) {
    return null;
  }

  if (status === "used" || status === "awaiting_payout") {
    return "submitted";
  }

  if (
    status === "invalid" ||
    status === "expired" ||
    status === "revoked"
  ) {
    return "unavailable";
  }

  if (
    surveyAccessData.can_access === false ||
    surveyAccessData.allowed === false
  ) {
    return "unavailable";
  }

  // `closed` alone is not enough — some access payloads include it on
  // otherwise valid unused links. Only block when status is also closed.
  if (surveyAccessData.closed === true && status === "closed") {
    return "unavailable";
  }

  return null;
};

export const getSurveyResponseIdStorageKey = (formId) =>
  formId ? `survey_${formId}_responseId` : null;

export const persistSurveyResponseId = (formId, responseId) => {
  const storageKey = getSurveyResponseIdStorageKey(formId);

  if (storageKey && responseId) {
    localStorage.setItem(storageKey, responseId);
  }
};
